import React from "react"
import ReactDOM from "react-dom"
import { StartPageApp } from "@cirrus/common/StartPage"

(function () {
  console.log("StartPageApp")
  ReactDOM.render(<StartPageApp />, document.getElementById("content-region"))
})()
